module.exports = __webpack_public_path__ + "img/v-q-2.9ebf77fb.jpg";